import { render, staticRenderFns } from "./UserGroupDetailTable.vue?vue&type=template&id=7985f045&scoped=true&"
import script from "./UserGroupDetailTable.vue?vue&type=script&lang=ts&"
export * from "./UserGroupDetailTable.vue?vue&type=script&lang=ts&"
import style0 from "./UserGroupDetailTable.vue?vue&type=style&index=0&id=7985f045&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7985f045",
  null
  
)

export default component.exports